import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 1792 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1792 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M1741.41696 289.024l-640 593.408a153.6 153.6 0 0 1-46.08 92.672 187.904 187.904 0 0 1-250.88 0l-15.36-13.312c-2.56-2.304-5.12-3.072-7.68-5.376s-2.56-5.376-5.12-7.68L51.81696 279.808a155.392 155.392 0 0 1 0-231.68 187.904 187.904 0 0 1 250.88 0l609.28 563.2L1500.77696 65.792a179.2 179.2 0 0 1 240.64 0 148.48 148.48 0 0 1 0 223.232z\" fill=\"#C9C4E4\" p-id=\"6447\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-down.svg
// module id = Peom
// module chunks = 156